var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 10 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 3.5A3.5 3.5 0 0 0 6 0H1.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1H6a3.49 3.49 0 0 0 2.44-6A3.5 3.5 0 0 0 9.5 3.5ZM6 10H2.5V7H6a1.5 1.5 0 0 1 0 3Zm0-5H2.5V2H6a1.5 1.5 0 0 1 0 3Z",
  fill: "currentColor"
})));

export default SvgBold;